/**
 * echoSimpsonTools.js — кнопка «ФВ по Симпсону (эхо)»: окно, обводка, расчёт. [12.0.42]
 *
 * ГДЕ СТОИТ. [12.0.46] Правая панель, своя вкладка «ЭхоКГ» (значок-сердце,
 * на телефоне — «ЭхоКГ» в ящике «Панели»). До 12.0.45 — раздел «УЗИ» во
 * вкладке «Клинические»; в 12.0.42–12.0.43 в журналах по ошибке стояло
 * «Анализ». Для МР-кино короткой оси есть своя кнопка «ФВ по маске
 * ЛЖ» (lvEfTools.js) — эта ей не замена: в эхо один срез, кровь тёмная, а
 * контур ведёт врач.
 *
 * ПОРЯДОК РАБОТЫ (он же написан в окне):
 *   1. Открыть эхо-кино 4-камерной позиции, нажать кнопку. Окно не мешает
 *      листать кадры — оно сбоку и не закрывает снимок.
 *   2. Масштаб: Pixel Spacing из файла, иначе шкала глубины на кадре
 *      (core/echoSimpson.js), иначе врач вводит сам. Число всегда видно и
 *      правится.
 *   3. Встать на кадр конца диастолы, «Обвести КД»: щелчки — кольцо МК, по
 *      эндокарду через верхушку, кольцо МК с другой стороны; двойной щелчок
 *      или «Готово». То же для конца систолы.
 *   4. По желанию — «Кадр следующего КД»: длина цикла → ЧСС и МО.
 *
 * ПОЧЕМУ СВОЯ ОБВОДКА, А НЕ ИНСТРУМЕНТЫ CORNERSTONE. У свободного ROI, сплайна
 * и Livewire контур замкнут, и по нему нельзя понять, где фиброзное кольцо:
 * Cornerstone переворачивает порядок точек (updateWindingDirection), а сплайн и
 * Livewire замыкают основание кривой. Методу дисков нужно ровно кольцо МК —
 * поэтому первая и последняя точки ставятся врачом, а основание — прямая.
 *
 * ПОЧЕМУ ГЕОМЕТРИЯ ОКНА, А НЕ worldToImageCoords. Провайдер метаданных
 * программы отдаёт плоскость снимка без rowCosines/columnCosines — на таком
 * снимке утилиты Cornerstone падают (см. toolManager.js, sliceGridOverlay.js).
 * Пиксель считается так же, как у самого StackViewport (canvasToWorldCPU):
 * разность с origin, проекция на оси direction, деление на spacing — всё из
 * vp.getImageData().
 *
 * Вся математика — в core/echoSimpson.js (tests/echosimpson_test.mjs); здесь
 * только Cornerstone (кадр, щелчок, рисование поверх) и окно.
 *
 * [12.0.43] ВТОРАЯ ВКЛАДКА «Камеры и кольца» (своя кнопка btn-echo-chambers
 * открывает окно сразу на ней). Из того же клипа: ЛП и ПП (обводка по кольцу
 * МК/ТК через крышу), ПЖ в конце диастолы и систолы (FAC), три отрезка ПЖ,
 * кольца ТК и МК, рост и вес для индексов; ЛЖ — площади, FAC и индекс
 * сферичности из контуров Симпсона. Обводка, масштаб и рисунок — общие: ради
 * этого вкладка, а не второе окно. Замеры разных видов лежат в состоянии под
 * своими ключами (кд, кс, лп, пп, пжкд, пжкс, пж1…пж3, тк, мк), их свойства —
 * в таблице ВИДЫ. Пороги и сводка — в ядре (итогКамер), здесь их нет.
 *
 * [12.0.44] ТРЕТЬЯ ВКЛАДКА «Движение колец» (кнопка btn-echo-motion). Врач
 * проводит линию через кольцо к верхушке — два щелчка, как отрезок (виды
 * двтк, двмкс, двмкл). По ней из ВСЕХ кадров собирается анатомический
 * М-режим (core/echoMotion.js: столбецМ), на нём ищется след переднего края
 * кольца (следКольца). Картинка М-режима со следом, концами диастолы и
 * систолы и текущим кадром рисуется в окне; щелчок по ней — переход к кадру,
 * а в режиме «КД»/«КС» — ручная отметка (она главнее следа). Числа, пороги и
 * выбор фаз — в ядре (итогДвижения). Слежение за точкой по пятнам ткани было
 * сделано и отброшено — почему, написано в ядре.
 *
 * [12.0.45] МАСШТАБ ПО МЕТКАМ ЛИНЕЙКИ (кнопка рядом с полем масштаба, вид
 * 'метки' вне ВИДЫ): два щелчка по меткам линейки глубины и сантиметры между
 * ними — core/echoSimpson.js: масштабПоМеткам. Для архивных клипов, где
 * линейка идёт наклонно вдоль края сектора и сама не находится.
 *
 * НЕ ПРОВЕРЕНО НА ЖИВОЙ ПРОГРАММЕ: у меня не было собранной сборки. Проверено
 * ядро на фантомах и на присланном кадре Mindray; обвязка — чтением исходников
 * Cornerstone 5.6.3.
 */

import { showToast, escapeHtml } from '../utils/helpers.js';
import { log } from '../utils/logger.js';
import { getDICOMTags } from '../loaders/loaderManager.js';
import { getRenderingEngine, getActiveOrFirstViewportId, cornerstone } from '../core/viewportState.js';
import { шкалаГлубины, шагИзТега, выбратьМасштаб, масштабПоМеткам, объёмДисками, итогСимпсона, оговоркиСимпсона,
  отрезокММ, итогКамер, оговоркиКамер, итогБиплана, итогДлиннойОси, оговоркиДлиннойОси } from '../core/echoSimpson.js';
import { ЛИНИИ, линияМ, точкаЛинии, столбецМ, следКольца, итогДвижения, оговоркиДвижения } from '../core/echoMotion.js';

const $ = (id) => document.getElementById(id);
const запятая = (x, знаков) => (Number.isFinite(x) ? x.toFixed(знаков).replace('.', ',') : '—');
/** 1 кадр, 21 кадр, 24 кадра, 30 кадров. */
function кадровСлово(n) {
  const д = n % 100, е = n % 10;
  return `${n} ${(д >= 11 && д <= 14) ? 'кадров' : (е === 1 ? 'кадр' : (е >= 2 && е <= 4 ? 'кадра' : 'кадров'))}`;
}
const СОБЫТИЕ_ОТРИСОВКИ = cornerstone?.Enums?.Events?.IMAGE_RENDERED || 'CORNERSTONE_IMAGE_RENDERED';

let _ac = null;

/** Состояние одного открытого окна. */
const с = {
  окно: null, svg: null, vp: null, элемент: null, ac: null,
  масштаб: { мм: null, откуда: '', файл: null, шкала: null },
  мсНаКадр: null, откудаВремя: '',
  кд: null, кс: null, следующийКД: null,
  обводка: null, обводкаAC: null,
  вкладка: 'фв', рост: null, вес: null,   // [12.0.43]
  движение: {}, ставлю: null,              // [12.0.44] по ключам ЛИНИИ; ставлю = {ключ, вид:'кд'|'кс'}
  метки: null, смМеток: 5,                  // [12.0.45] две метки линейки для масштаба (вид 'метки')
  пол: null, серияОкна: '',                 // [12.0.47] пол для порогов длинной оси; серия, для которой прочитан масштаб
};

/**
 * [12.0.43] Виды замеров. «контур» — щелчки от кольца через дальнюю стенку к
 * кольцу, считается методом дисков (у ПЖ берётся только площадь); «отрезок» —
 * две точки, обводка кончается на второй сама.
 */
const ВИДЫ = Object.freeze({
  кд:   { тип: 'контур',  кольцо: 'МК', цвет: '#58a6ff', метка: 'КД',   имя: 'ЛЖ, конец диастолы',
          подсказка: 'кольцо МК, дальше по эндокарду через верхушку, последний — кольцо МК с другой стороны' },
  кс:   { тип: 'контур',  кольцо: 'МК', цвет: '#f0883e', метка: 'КС',   имя: 'ЛЖ, конец систолы',
          подсказка: 'кольцо МК, дальше по эндокарду через верхушку, последний — кольцо МК с другой стороны' },
  лп:   { тип: 'контур',  кольцо: 'МК', цвет: '#d2a8ff', метка: 'ЛП',   имя: 'ЛП (кадр конца систолы ЛЖ)',
          подсказка: 'кольцо МК, по стенке ЛП через крышу, кольцо МК с другой стороны; устья лёгочных вен и ушко не включать' },
  пп:   { тип: 'контур',  кольцо: 'ТК', цвет: '#ff7b72', метка: 'ПП',   имя: 'ПП (кадр конца систолы)',
          подсказка: 'кольцо ТК, по стенке ПП через крышу, кольцо ТК с другой стороны; устья полых вен не включать' },
  пжкд: { тип: 'контур',  кольцо: 'ТК', цвет: '#56d364', метка: 'ПЖд',  имя: 'ПЖ, конец диастолы',
          подсказка: 'латеральное кольцо ТК, по эндокарду ПЖ через верхушку, септальное кольцо ТК; трабекулы и модераторный тяж — внутрь полости' },
  пжкс: { тип: 'контур',  кольцо: 'ТК', цвет: '#2ea043', метка: 'ПЖс',  имя: 'ПЖ, конец систолы',
          подсказка: 'латеральное кольцо ТК, по эндокарду ПЖ через верхушку, септальное кольцо ТК; трабекулы и модераторный тяж — внутрь полости' },
  пж1:  { тип: 'отрезок', цвет: '#e3b341', метка: 'ПЖ1', имя: 'ПЖ базальный поперечник (КД)', подсказка: 'поперёк базальной трети ПЖ, от стенки до стенки' },
  пж2:  { тип: 'отрезок', цвет: '#d29922', метка: 'ПЖ2', имя: 'ПЖ средний поперечник (КД)',   подсказка: 'поперёк ПЖ на уровне папиллярных мышц ЛЖ' },
  пж3:  { тип: 'отрезок', цвет: '#bb8009', метка: 'ПЖ3', имя: 'ПЖ длина (КД)',                подсказка: 'от середины кольца ТК до верхушки ПЖ' },
  тк:   { тип: 'отрезок', цвет: '#79c0ff', метка: 'ТК',  имя: 'Кольцо ТК (КД)',               подсказка: 'от септального до латерального края кольца ТК' },
  мк:   { тип: 'отрезок', цвет: '#a5d6ff', метка: 'МК',  имя: 'Кольцо МК',                    подсказка: 'от края до края кольца МК' },
  // [12.0.47] 2-камерная позиция — для ФВ двумя плоскостями (обычно другой клип).
  кд2:  { тип: 'контур',  кольцо: 'МК', цвет: '#79c0ff', метка: 'КД2',  имя: 'ЛЖ, конец диастолы (2-камерная)',
          подсказка: 'кольцо МК (нижняя стенка), по эндокарду через верхушку, кольцо МК (передняя стенка)' },
  кс2:  { тип: 'контур',  кольцо: 'МК', цвет: '#ffa657', метка: 'КС2',  имя: 'ЛЖ, конец систолы (2-камерная)',
          подсказка: 'кольцо МК (нижняя стенка), по эндокарду через верхушку, кольцо МК (передняя стенка)' },
  // [12.0.47] Парастернальная длинная ось — линейные размеры.
  мжп:  { тип: 'отрезок', цвет: '#f778ba', метка: 'МЖП',  имя: 'МЖП (конец диастолы)',  подсказка: 'толщина перегородки поперёк длинной оси, на уровне концов створок МК' },
  кдр:  { тип: 'отрезок', цвет: '#58a6ff', метка: 'КДР',  имя: 'КДР (конец диастолы)',  подсказка: 'полость ЛЖ от эндокарда перегородки до эндокарда задней стенки, там же' },
  зслж: { тип: 'отрезок', цвет: '#db61a2', метка: 'ЗСЛЖ', имя: 'ЗСЛЖ (конец диастолы)', подсказка: 'толщина задней стенки, там же, без хорд и перикарда' },
  кср:  { тип: 'отрезок', цвет: '#f0883e', метка: 'КСР',  имя: 'КСР (конец систолы)',   подсказка: 'полость ЛЖ в конце систолы, на том же уровне' },
  втлж: { тип: 'отрезок', цвет: '#a371f7', метка: 'ВТЛЖ', имя: 'ВТЛЖ (середина систолы)', подсказка: 'диаметр выносящего тракта у прикрепления створок аортального клапана' },
  аорта:{ тип: 'отрезок', цвет: '#e3b341', метка: 'Ао',   имя: 'Корень аорты (синусы, КД)', подсказка: 'наибольший диаметр на уровне синусов Вальсальвы' },
  лпд:  { тип: 'отрезок', цвет: '#d2a8ff', метка: 'ЛП',   имя: 'ЛП переднезадний (КС)',  подсказка: 'от задней стенки аорты до задней стенки ЛП, в конце систолы' },
  // [12.0.44] Линии М-режима: первый щелчок — на кольцо, второй — к верхушке.
  двтк:  { тип: 'линия', линия: 'тк',  цвет: '#ffa657', метка: 'М-ТК',  имя: 'Линия через латеральное кольцо ТК',
           подсказка: 'первый — на латеральное кольцо ТК, на его край со стороны ПЖ; второй — к верхушке, по ходу движения кольца, на 2–3 см' },
  двмкс: { тип: 'линия', линия: 'мкс', цвет: '#a5d6ff', метка: 'М-МКс', имя: 'Линия через септальное кольцо МК',
           подсказка: 'первый — на септальное кольцо МК, на его край со стороны ЛЖ; второй — к верхушке, вдоль перегородки, на 2–3 см' },
  двмкл: { тип: 'линия', линия: 'мкл', цвет: '#79c0ff', метка: 'М-МКл', имя: 'Линия через латеральное кольцо МК',
           подсказка: 'первый — на латеральное кольцо МК, на его край со стороны ЛЖ; второй — к верхушке, вдоль боковой стенки, на 2–3 см' },
});
const ДВИЖЕНИЕ = ['двтк', 'двмкс', 'двмкл'];
// [12.0.45] Две метки линейки глубины — масштаб, когда шкалу не нашли сами.
// Вид живёт вне ВИДЫ: это не замер, у него нет строки в таблицах и отчёте.
const МЕТКИ = { тип: 'метки', цвет: '#e3b341', метка: 'Линейка', имя: 'Две метки линейки глубины',
  подсказка: 'две метки линейки глубины подальше друг от друга (например, «5» и «10»); потом введите, сколько сантиметров между ними' };
const вид_ = (что) => (что === 'метки' ? МЕТКИ : ВИДЫ[что]);
const двуточечный = (что) => ['отрезок', 'линия', 'метки'].includes(вид_(что)?.тип);
const КАМЕРЫ = ['лп', 'пп', 'пжкд', 'пжкс', 'пж1', 'пж2', 'пж3', 'тк', 'мк'];
const ОСЬ = ['мжп', 'кдр', 'зслж', 'кср', 'втлж', 'аорта', 'лпд'];   // [12.0.47]

/** [12.0.47] Серия (клип) в окне — по первому снимку. 4- и 2-камерная обычно разные клипы. */
function серия() {
  try { return String(с.vp?.getImageIds?.()?.[0] || ''); } catch (e) { return ''; }
}
const наЭтойСерии = (замер) => !замер?.серия || замер.серия === серия();

// ══════════════════════════════════════════════════════════════
//  Окно Cornerstone: кадр, геометрия, пиксели
// ══════════════════════════════════════════════════════════════

function активноеОкно() {
  const re = getRenderingEngine?.();
  const id = getActiveOrFirstViewportId?.();
  const vp = re && id ? re.getViewport(id) : null;
  if (!vp) return { ок: false, причина: 'нет окна со снимком' };
  const нужно = ['getCurrentImageIdIndex', 'getImageIds', 'canvasToWorld', 'worldToCanvas', 'getImageData'];
  if (!нужно.every((м) => typeof vp[м] === 'function')) {
    return { ок: false, причина: 'активное окно — не окно кадров (откройте эхо-кино в обычном окне, не в MPR/3D)' };
  }
  return { ок: true, vp, элемент: vp.element };
}

/**
 * Пиксель ↔ мир по геометрии самого окна — та же формула, что у
 * StackViewport.canvasToWorldCPU / worldToCanvasCPU в Cornerstone 5.6.3.
 */
function геометрия(vp) {
  let д = null;
  try { д = vp.getImageData(); } catch (e) { д = null; }
  if (!д?.origin || !д?.spacing || !д?.direction) return null;
  const o = д.origin, sp = д.spacing, dir = д.direction;
  const i = [dir[0], dir[1], dir[2]], j = [dir[3], dir[4], dir[5]];
  if (!(sp[0] > 0 && sp[1] > 0)) return null;
  return {
    вПиксель(w) {
      const d = [w[0] - o[0], w[1] - o[1], w[2] - o[2]];
      return [(d[0] * i[0] + d[1] * i[1] + d[2] * i[2]) / sp[0], (d[0] * j[0] + d[1] * j[1] + d[2] * j[2]) / sp[1]];
    },
    вМир(p) {
      return [0, 1, 2].map((k) => o[k] + i[k] * p[0] * sp[0] + j[k] * p[1] * sp[1]);
    },
  };
}

/** Яркость текущего кадра (среднее трёх каналов — как при переделке AVI). */
async function серыйКадр(imageId) {
  const image = await cornerstone.imageLoader.loadAndCacheImage(imageId);
  const п = image.getPixelData();
  const w = image.columns, h = image.rows;
  const комп = Math.round(п.length / (w * h));
  if (!(w > 0 && h > 0) || ![1, 3, 4].includes(комп)) return null;
  const г = new Uint8Array(w * h);
  if (комп === 1) {
    // Серый 8 бит — как есть; шире — приводим к 0…255 по размаху.
    let мин = Infinity, макс = -Infinity;
    for (let k = 0; k < г.length; k++) { const v = п[k]; if (v < мин) мин = v; if (v > макс) макс = v; }
    const к = макс > мин ? 255 / (макс - мин) : 1;
    for (let k = 0; k < г.length; k++) г[k] = ((п[k] - мин) * к) | 0;
  } else {
    for (let k = 0, q = 0; k < г.length; k++, q += комп) г[k] = ((п[q] + п[q + 1] + п[q + 2]) / 3) | 0;
  }
  return { серый: г, w, h };
}

/** Масштаб: Pixel Spacing файла → шкала глубины → вручную. Правило — в ядре. */
async function определитьМасштаб(imageId) {
  let теги = {};
  try { теги = await getDICOMTags(imageId); } catch (e) { log.debug('[Симпсон] теги', e.message); }
  const файл = шагИзТега(теги?.['x00280030']?.value);   // «1\1» — подстановка программы, не масштаб
  let шкала = null;
  try {
    const к = await серыйКадр(imageId);
    if (к) {
      const ш = шкалаГлубины(к.серый, к.w, к.h);
      if (ш.ок) шкала = ш;
      else log.info('[Симпсон] ' + ш.причина);
    }
  } catch (e) { log.debug('[Симпсон] кадр для шкалы', e.message); }
  return { ...выбратьМасштаб(файл, шкала), файл, шкала };
}

/** Время кадра, мс: Frame Time → Cine Rate → Recommended Display Frame Rate. */
async function времяКадра(imageId) {
  let теги = {};
  try { теги = await getDICOMTags(imageId); } catch (e) { return { мс: null, откуда: '' }; }
  const ч = (т) => Number(String(теги?.[т]?.value || '').split('\\')[0]);
  // [12.0.43] Рост (м) и вес (кг) пациента, если аппарат их записал, — для индексов.
  if (с.рост == null && ч('x00101020') > 0.4 && ч('x00101020') < 2.5) с.рост = Math.round(ч('x00101020') * 100);
  if (с.вес == null && ч('x00101030') > 2 && ч('x00101030') < 400) с.вес = ч('x00101030');
  // [12.0.47] Пол — для норм длинной оси (M/F в теге Patient's Sex).
  const пол = String(теги?.['x00100040']?.value || '').trim().toUpperCase();
  if (с.пол == null && (пол === 'M' || пол === 'F')) с.пол = пол === 'M' ? 'м' : 'ж';
  if (ч('x00181063') > 0) return { мс: ч('x00181063'), откуда: 'Frame Time' };
  if (ч('x00180040') > 0) return { мс: 1000 / ч('x00180040'), откуда: 'Cine Rate' };
  if (ч('x00082144') > 0) return { мс: 1000 / ч('x00082144'), откуда: 'Recommended Display Frame Rate' };
  return { мс: null, откуда: '' };
}

// ══════════════════════════════════════════════════════════════
//  Расчёт
// ══════════════════════════════════════════════════════════════

/** Пересчитать замер при новом масштабе. Без масштаба — в пикселях (для ФВ и FAC этого хватает). */
function пересчитать(замер) {
  if (!замер) return;
  const в = ВИДЫ[замер.вид] || ВИДЫ.кд;
  if (в.тип === 'линия') { замер.итог = { ок: true }; return; }   // числа — по картинке М-режима
  // [12.0.47] Масштаб у замера свой: замер на другой серии считается по
  // масштабу, с которым его сделали; на этой — по текущему.
  if (наЭтойСерии(замер)) замер.мм = с.масштаб.мм > 0 ? с.масштаб.мм : null;
  const мм = замер.мм || 1;
  замер.итог = в.тип === 'отрезок'
    ? отрезокММ(замер.пикс[0], замер.пикс[1], мм)
    : объёмДисками(замер.пикс, мм, { кольцо: в.кольцо });
}

/** [12.0.47] Без масштаба у всех четырёх или с ним у всех — иначе объёмы несравнимы. */
function итогДвух() {
  const к = ['кд', 'кс', 'кд2', 'кс2'].map((в) => с[в]);
  if (!к.every((з) => з?.итог?.ок)) return null;
  const сМасштабом = к.filter((з) => з.мм > 0).length;
  if (сМасштабом !== 0 && сМасштабом !== 4) return { ок: false, причина: 'у части контуров есть масштаб, у части нет — задайте масштаб в обеих позициях' };
  const кадровВЦикле = (с.следующийКД != null) ? Math.abs(с.следующийКД - с.кд.кадр) : null;
  return итогБиплана({ кд4: с.кд.итог, кс4: с.кс.итог, кд2: с.кд2.итог, кс2: с.кс2.итог, кадровВЦикле: кадровВЦикле || null, мсНаКадр: с.мсНаКадр });
}

/** [12.0.47] Сводка по длинной оси — из ядра. Без масштаба линейных чисел нет. */
function итогОсиОкна() {
  const и = (вид) => (с[вид]?.мм > 0 ? с[вид].итог : null);
  return итогДлиннойОси({ мжп: и('мжп'), кдр: и('кдр'), зслж: и('зслж'), кср: и('кср'), втлж: и('втлж'), аорта: и('аорта'), лп: и('лпд'),
    пол: с.пол, рост: с.рост, вес: с.вес });
}

function итог() {
  if (!с.кд?.итог?.ок || !с.кс?.итог?.ок) return null;
  const кадровВЦикле = (с.следующийКД != null) ? Math.abs(с.следующийКД - с.кд.кадр) : null;
  return итогСимпсона({ кд: с.кд.итог, кс: с.кс.итог, кадровВЦикле: кадровВЦикле || null, мсНаКадр: с.мсНаКадр });
}

/**
 * [12.0.43] Сводка по камерам — из ядра. Без масштаба остаются только строки,
 * которым масштаб не нужен: FAC (отношение площадей) и индекс сферичности.
 */
function итогКамерОкна() {
  const и = (вид) => с[вид]?.итог || null;
  const св = итогКамер({
    лжКД: и('кд'), лжКС: и('кс'), лп: и('лп'), пп: и('пп'), пжКД: и('пжкд'), пжКС: и('пжкс'),
    пж1: и('пж1'), пж2: и('пж2'), пж3: и('пж3'), тк: и('тк'), мк: и('мк'), рост: с.рост, вес: с.вес,
  });
  if (!(с.масштаб.мм > 0)) св.строки = св.строки.filter((ст) => ст.ед === '%' || ст.ед === '');
  return св;
}

// ══════════════════════════════════════════════════════════════
//  Рисование поверх снимка
// ══════════════════════════════════════════════════════════════

function нарисовать() {
  if (!с.svg || !с.vp) return;
  let кадр;
  try { кадр = с.vp.getCurrentImageIdIndex(); } catch (e) { return; }
  const г = геометрия(с.vp);
  const вХолст = (мир) => { try { const p = с.vp.worldToCanvas(мир); return Number.isFinite(p?.[0]) ? p : null; } catch (e) { return null; } };
  const изПикселя = (p) => (г ? вХолст(г.вМир(p)) : null);
  const т = (p) => `${p[0].toFixed(1)},${p[1].toFixed(1)}`;
  const части = [];
  for (const [вид, в] of Object.entries(ВИДЫ)) {
    const к = с[вид];
    if (!к || !наЭтойСерии(к) || (к.кадр !== кадр && в.тип !== 'линия')) continue;
    const pts = к.мир.map(вХолст).filter(Boolean);
    if (pts.length < 2) continue;
    const цвет = в.цвет, подпись = в.метка;
    if (в.тип === 'линия') {
      // [12.0.44] Линия М-режима целиком (с продолжением за кольцо) и где кольцо на этом кадре.
      const д = с.движение[в.линия];
      if (д?.линия?.ок && (!д.серия || д.серия === серия())) {
        const A = изПикселя(д.линия.начало), B = изПикселя(точкаЛинии(д.линия, д.линия.длина));
        if (A && B) части.push(`<line x1="${A[0]}" y1="${A[1]}" x2="${B[0]}" y2="${B[1]}" stroke="${цвет}" stroke-width="1.5" stroke-dasharray="6 4"/>`);
        if (B) части.push(`<text x="${B[0] + 6}" y="${B[1] - 6}" fill="${цвет}" font-size="13" font-weight="700">${подпись}</text>`);
      }
      continue;
    }
    if (в.тип === 'отрезок') {
      части.push(`<line x1="${pts[0][0]}" y1="${pts[0][1]}" x2="${pts[1][0]}" y2="${pts[1][1]}" stroke="${цвет}" stroke-width="2"/>`);
      for (const p of pts) части.push(`<circle cx="${p[0]}" cy="${p[1]}" r="3.5" fill="${цвет}"/>`);
      части.push(`<text x="${pts[1][0] + 6}" y="${pts[1][1] - 6}" fill="${цвет}" font-size="13" font-weight="700">${подпись}</text>`);
      continue;
    }
    части.push(`<polyline points="${pts.map(т).join(' ')}" fill="none" stroke="${цвет}" stroke-width="2"/>`);
    части.push(`<line x1="${pts[0][0]}" y1="${pts[0][1]}" x2="${pts[pts.length - 1][0]}" y2="${pts[pts.length - 1][1]}" stroke="${цвет}" stroke-width="1.5" stroke-dasharray="5 4"/>`);
    if (к.итог?.ок) {
      // Диски — у тех, у кого считается объём (ЛЖ, ЛП, ПП); у ПЖ — только площадь.
      if (!вид.startsWith('пж')) {
        for (const [a, b] of к.итог.хорды) {
          const A = изПикселя(a), B = изПикселя(b);
          if (A && B) части.push(`<line x1="${A[0]}" y1="${A[1]}" x2="${B[0]}" y2="${B[1]}" stroke="${цвет}" stroke-width="0.8" stroke-opacity="0.55"/>`);
        }
      }
      const M = изПикселя(к.итог.серединаОснования), V = изПикселя(к.итог.верхушка);
      if (M && V) {
        if (!вид.startsWith('пж')) части.push(`<line x1="${M[0]}" y1="${M[1]}" x2="${V[0]}" y2="${V[1]}" stroke="${цвет}" stroke-width="1" stroke-dasharray="2 3"/>`);
        части.push(`<text x="${V[0] + 6}" y="${V[1] - 6}" fill="${цвет}" font-size="14" font-weight="700">${подпись}</text>`);
      }
    }
  }
  // [12.0.45] Метки линейки, по которым взят масштаб, — на любом кадре.
  if (с.метки) {
    const pts = с.метки.мир.map(вХолст).filter(Boolean);
    if (pts.length === 2) {
      части.push(`<line x1="${pts[0][0]}" y1="${pts[0][1]}" x2="${pts[1][0]}" y2="${pts[1][1]}" stroke="${МЕТКИ.цвет}" stroke-width="1.5" stroke-dasharray="3 3"/>`);
      for (const p of pts) части.push(`<circle cx="${p[0]}" cy="${p[1]}" r="4" fill="none" stroke="${МЕТКИ.цвет}" stroke-width="2"/>`);
      части.push(`<text x="${pts[1][0] + 6}" y="${pts[1][1] + 14}" fill="${МЕТКИ.цвет}" font-size="12" font-weight="700">${запятая(с.смМеток, 1)} см</text>`);
    }
  }
  // [12.0.44] Где на этом кадре кольцо по следу (или нет следа — ничего).
  for (const вид of ДВИЖЕНИЕ) {
    const д = с.движение[ВИДЫ[вид].линия];
    const t = д?.след?.ок && (!д.серия || д.серия === серия()) ? д.след.след[кадр] : null;
    if (t == null) continue;
    const P = изПикселя(точкаЛинии(д.линия, t));
    if (P) части.push(`<circle cx="${P[0]}" cy="${P[1]}" r="5" fill="none" stroke="#ff5555" stroke-width="2"/>`);
  }
  const о = с.обводка;
  if (о && о.кадр === кадр) {
    const pts = о.мир.map(вХолст).filter(Boolean);
    if (pts.length >= 2) {
      части.push(`<polyline points="${pts.map(т).join(' ')}" fill="none" stroke="#7ee787" stroke-width="2"/>`);
      if (!двуточечный(о.что)) {
        части.push(`<line x1="${pts[0][0]}" y1="${pts[0][1]}" x2="${pts[pts.length - 1][0]}" y2="${pts[pts.length - 1][1]}" stroke="#7ee787" stroke-width="1" stroke-dasharray="4 4"/>`);
      }
    }
    pts.forEach((p, n) => части.push(`<circle cx="${p[0]}" cy="${p[1]}" r="${n === 0 || n === pts.length - 1 ? 4.5 : 3}" fill="#7ee787"/>`));
  }
  с.svg.innerHTML = части.join('');
}

function поставитьСлой() {
  const э = с.элемент;
  if (!э) return;
  const ns = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(ns, 'svg');
  svg.setAttribute('data-echo-simpson', '');
  svg.style.cssText = 'position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:6;overflow:visible;';
  if (getComputedStyle(э).position === 'static') э.style.position = 'relative';
  э.appendChild(svg);
  с.svg = svg;
  э.addEventListener(СОБЫТИЕ_ОТРИСОВКИ, нарисовать, { signal: с.ac.signal });
  window.addEventListener('resize', нарисовать, { signal: с.ac.signal });
}

// ══════════════════════════════════════════════════════════════
//  Обводка щелчками
// ══════════════════════════════════════════════════════════════

function начатьОбводку(что) {
  if (!с.vp || !вид_(что)) return;
  закончитьОбводкуСлужебно();
  let кадр;
  try { кадр = с.vp.getCurrentImageIdIndex(); } catch (e) { return; }
  с.обводка = { что, кадр, мир: [], холст: [] };
  const ac = new AbortController();
  с.обводкаAC = ac;
  const э = с.элемент;
  const отрезок = двуточечный(что);
  const внутри = (e) => э && e.target instanceof Node && э.contains(e.target);
  const глушить = (e) => { if (внутри(e)) { e.stopPropagation(); e.preventDefault(); } };
  const опц = { capture: true, signal: ac.signal };

  // Щелчки по снимку во время обводки не доходят до инструментов Cornerstone:
  // иначе Длина/ROI рисовали бы своё поверх, а W/L менял бы окно.
  document.addEventListener('pointerdown', (e) => {
    if (!внутри(e)) return;
    e.stopPropagation(); e.preventDefault();
    if (e.button != null && e.button !== 0) return;
    const r = э.getBoundingClientRect();
    const холст = [e.clientX - r.left, e.clientY - r.top];
    const посл = с.обводка.холст[с.обводка.холст.length - 1];
    if (посл && Math.hypot(холст[0] - посл[0], холст[1] - посл[1]) < 4) return;   // второй щелчок двойного
    let мир = null;
    try { мир = с.vp.canvasToWorld(холст); } catch (err) { мир = null; }
    if (!мир) return;
    с.обводка.мир.push([мир[0], мир[1], мир[2]]);
    с.обводка.холст.push(холст);
    нарисовать(); обновитьОкно();
    // Отрезок — две точки. Кончаем НЕ здесь: у этого же нажатия впереди ещё
    // mouseup и click, и если снять перехват сейчас, click дойдёт до
    // инструментов снимка («Длина» начала бы свой отрезок) — поймано стендом.
    // Кончаем на click этого нажатия; не пришёл — через полсекунды.
    if (отрезок && с.обводка.мир.length >= 2 && !с.обводка.кончить) {
      с.обводка.кончить = true;
      setTimeout(() => { if (с.обводка?.кончить && с.обводкаAC === ac) закончитьОбводку(); }, 500);
    }
  }, опц);
  for (const тип of ['mousedown', 'mouseup', 'pointerup', 'touchstart', 'touchend', 'contextmenu']) {
    document.addEventListener(тип, глушить, опц);
  }
  document.addEventListener('click', (e) => {
    if (!внутри(e)) return;
    глушить(e);
    if (с.обводка?.кончить) закончитьОбводку();
  }, опц);
  document.addEventListener('dblclick', (e) => { if (внутри(e)) { глушить(e); закончитьОбводку(); } }, опц);
  document.addEventListener('keydown', (e) => {
    if (e.target?.closest?.('input, textarea, select, [contenteditable]')) return;   // правка поля — не обводка
    if (e.key === 'Enter') { e.preventDefault(); e.stopImmediatePropagation(); закончитьОбводку(); }
    else if (e.key === 'Escape') { e.preventDefault(); e.stopImmediatePropagation(); отменитьОбводку(); }
    else if (e.key === 'Backspace') { e.preventDefault(); e.stopImmediatePropagation(); убратьТочку(); }
  }, опц);
  if (э) э.style.cursor = 'crosshair';
  обновитьОкно();
}

function закончитьОбводкуСлужебно() {
  try { с.обводкаAC?.abort(); } catch (e) { /* */ }
  с.обводкаAC = null;
  if (с.элемент) с.элемент.style.cursor = '';
}

function убратьТочку() {
  if (!с.обводка) return;
  с.обводка.мир.pop(); с.обводка.холст.pop();
  нарисовать(); обновитьОкно();
}

function отменитьОбводку() {
  с.обводка = null;
  закончитьОбводкуСлужебно();
  нарисовать(); обновитьОкно();
}

function закончитьОбводку() {
  const о = с.обводка;
  if (!о) return;
  const в = вид_(о.что);
  if (двуточечный(о.что) && о.мир.length < 2) { showToast(в.тип === 'линия' ? 'Линии нужны два щелчка: на кольцо и к верхушке' : 'Отрезку нужны две точки', 'warning', 3000); return; }
  if (!двуточечный(о.что) && о.мир.length < 5) {
    showToast(`Нужно не меньше 5 точек: кольцо ${в.кольцо}, три по стенке, кольцо ${в.кольцо} с другой стороны`, 'warning', 5000);
    return;
  }
  const г = геометрия(с.vp);
  if (!г) { showToast('Не удалось пересчитать точки в пиксели: у окна нет геометрии снимка', 'error', 6000); return; }
  const замер = { вид: о.что, кадр: о.кадр, мир: двуточечный(о.что) ? о.мир.slice(0, 2) : о.мир, пикс: null, итог: null };
  замер.пикс = замер.мир.map((w) => г.вПиксель(w));
  замер.серия = серия();                                   // [12.0.47]
  if (о.что === 'метки') {
    // [12.0.45] Метки линейки: сразу масштаб по сантиметрам из поля (сначала 5).
    с.метки = замер; с.обводка = null;
    закончитьОбводкуСлужебно();
    применитьМетки();
    нарисовать(); обновитьОкно();
    return;
  }
  пересчитать(замер);
  с[о.что] = замер;
  с.обводка = null;
  закончитьОбводкуСлужебно();
  if (!замер.итог.ок) showToast(`${в.имя}: не посчитано — ${замер.итог.причина}`, 'warning', 7000);
  нарисовать(); обновитьОкно();
  if (в.тип === 'линия') построитьМ(в.линия, замер);
}

// ══════════════════════════════════════════════════════════════
//  Окно
// ══════════════════════════════════════════════════════════════

const СТИЛЬ_КНОПКИ = 'padding:7px 10px;border-radius:8px;border:1px solid #2a3546;background:#1a2332;color:#dbe6f5;font-size:12.5px;cursor:pointer;';
const СТИЛЬ_ССЫЛКИ = 'margin-left:4px;padding:1px 6px;border-radius:6px;border:1px solid #2a3546;background:transparent;color:#9fb3cf;font-size:11.5px;cursor:pointer;';
const СТИЛЬ_ПОЛЯ = 'padding:3px 6px;border-radius:6px;border:1px solid #2a3546;background:#0b1018;color:#dbe6f5;';
const СТИЛЬ_ОГОВОРОК = 'margin-top:10px;padding:8px 10px;border-radius:8px;background:rgba(60,50,10,0.5);border:1px solid #a88;color:#e8d9a8;font-size:12px;';

/** Подпись кнопки замера с номером текущего кадра. */
function подписьКнопки(вид, кадр) {
  const в = ВИДЫ[вид];
  const глагол = в.тип === 'линия' ? 'Линия' : (в.тип === 'отрезок' ? 'Отрезок' : 'Обвести');
  return `${глагол} ${в.метка} (кадр ${кадр != null ? кадр + 1 : '—'})`;
}

function строкаКонтура(что, имя) {
  const к = с[что];
  if (!к) return `<div style="color:#8fa3c0;">${имя}: не обведён</div>`;
  const и = к.итог;
  if (!и?.ок) return `<div style="color:#ffb4a8;">${имя}, кадр ${к.кадр + 1}: ${escapeHtml(и?.причина || 'не посчитан')}</div>`;
  const есть = к.мм > 0;
  const где = наЭтойСерии(к) ? '' : ' <span style="color:#8fa3c0;">(другой клип)</span>';
  return `<div>${имя}, кадр ${к.кадр + 1}${где}: `
    + (есть
      ? `объём <b>${запятая(и.объёмМЛ, 0)} мл</b>, длина ЛЖ ${запятая(и.длинаММ / 10, 1)} см, площадь ${запятая(и.площадьММ2 / 100, 1)} см²`
        + ` <span style="color:#8fa3c0;">(площадь-длина ${запятая(и.объёмПлощадьДлинаМЛ, 0)} мл)</span>`
      : `контур из ${к.пикс.length} точек, объём — после ввода масштаба`)
    + ` <button data-перейти="${что}" style="${СТИЛЬ_ССЫЛКИ}">к кадру</button></div>`;
}

/** [12.0.43] Короткая строка состояния замера камер. */
function строкаЗамера(вид) {
  const в = ВИДЫ[вид], з = с[вид];
  if (!з) return `<span style="color:#8fa3c0;">не отмечен</span>`;
  const и = з.итог;
  if (!и?.ок) return `<span style="color:#ffb4a8;">кадр ${з.кадр + 1}: ${escapeHtml(и?.причина || 'не посчитан')}</span>`;
  const есть = з.мм > 0;
  let текст;
  if (!есть) текст = 'обведено, числа — после ввода масштаба';
  else if (в.тип === 'отрезок') текст = `${запятая(и.длинаММ, 0)} мм`;
  else if (вид.startsWith('пж')) текст = `площадь ${запятая(и.площадьММ2 / 100, 1)} см²`;
  else текст = `площадь ${запятая(и.площадьММ2 / 100, 1)} см², объём ${запятая(и.объёмМЛ, 0)} мл`;
  return `кадр ${з.кадр + 1}: ${текст} <button data-перейти="${вид}" style="${СТИЛЬ_ССЫЛКИ}">к кадру</button>`;
}

/** [12.0.47] Итог двумя плоскостями — над одноплоскостным, когда есть все четыре контура. */
function текстИтогаДвух() {
  const и = итогДвух();
  if (!и) return '';
  if (!и.ок) return `<div style="margin-top:8px;padding:8px 10px;border-radius:8px;background:rgba(120,20,20,0.5);border:1px solid #e66;color:#ffd9d9;">Две плоскости: ${escapeHtml(и.причина)}</div>`;
  const есть = с.кд.мм > 0;
  const стр = [`<div style="margin-top:8px;font-size:22px;font-weight:800;color:#7ee787;">ФВ ${запятая(и.фв * 100, 0)}% <span style="font-size:13px;font-weight:600;">две плоскости</span></div>`];
  if (есть) стр.push(`<div>КДО ${запятая(и.кдоМЛ, 0)} мл · КСО ${запятая(и.ксоМЛ, 0)} мл · УО ${запятая(и.уоМЛ, 0)} мл (две плоскости)</div>`);
  for (const о of и.оговорки) стр.push(`<div style="color:#e8d9a8;">${escapeHtml(о)}</div>`);
  стр.push('<div style="color:#8fa3c0;font-size:12px;margin-top:4px;">Ниже — та же ФВ по одной 4-камерной позиции.</div>');
  return стр.join('');
}

function текстИтога() {
  const и = итог();
  if (!и) return '';
  if (!и.ок) return `<div style="margin-top:8px;padding:8px 10px;border-radius:8px;background:rgba(120,20,20,0.5);border:1px solid #e66;color:#ffd9d9;">${escapeHtml(и.причина)}</div>`;
  const есть = с.кд?.мм > 0;
  const стр = [];
  стр.push(`<div style="margin-top:8px;font-size:22px;font-weight:800;color:#7ee787;">ФВ ${запятая(и.фв * 100, 0)}%</div>`);
  if (есть) {
    стр.push(`<div>КДО ${запятая(и.кдоМЛ, 0)} мл · КСО ${запятая(и.ксоМЛ, 0)} мл · УО ${запятая(и.уоМЛ, 0)} мл</div>`);
  } else {
    стр.push('<div style="color:#e8d9a8;">КДО, КСО и УО — после ввода масштаба; ФВ от масштаба не зависит.</div>');
  }
  if (и.чсс) {
    стр.push(`<div>ЧСС ${запятая(и.чсс, 0)} в минуту (цикл ${запятая(и.циклМС, 0)} мс)${есть ? ` · МО ${запятая(и.моЛМин, 1)} л/мин` : ''}</div>`);
  }
  for (const о of и.оговорки) стр.push(`<div style="color:#e8d9a8;">${escapeHtml(о)}</div>`);
  return стр.join('');
}

function вкладкаФВ(стр, текущий) {
  стр.push(`<div style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:6px;">`
    + `<button data-обвести="кд" style="${СТИЛЬ_КНОПКИ}">${подписьКнопки('кд', текущий)}</button>`
    + `<button data-обвести="кс" style="${СТИЛЬ_КНОПКИ}">${подписьКнопки('кс', текущий)}</button></div>`);
  стр.push(строкаКонтура('кд', 'КД'));
  стр.push(строкаКонтура('кс', 'КС'));
  // [12.0.47] 2-камерная позиция — для двух плоскостей. Откройте её клип и обведите там.
  стр.push(`<div style="margin-top:8px;font-weight:700;color:#c9d6ea;">2-камерная позиция — для ФВ двумя плоскостями</div>`
    + `<div style="color:#8fa3c0;font-size:12px;">Откройте клип 2-камерной позиции в этом же окне снимка — обведённое в 4-камерной сохранится.</div>`
    + `<div style="display:flex;gap:6px;flex-wrap:wrap;margin:4px 0 6px;">`
    + `<button data-обвести="кд2" style="${СТИЛЬ_КНОПКИ}">${подписьКнопки('кд2', текущий)}</button>`
    + `<button data-обвести="кс2" style="${СТИЛЬ_КНОПКИ}">${подписьКнопки('кс2', текущий)}</button></div>`);
  стр.push(строкаКонтура('кд2', 'КД (2к)'));
  стр.push(строкаКонтура('кс2', 'КС (2к)'));
  const цикл = с.следующийКД != null && с.кд ? Math.abs(с.следующийКД - с.кд.кадр) : null;
  стр.push(`<div style="margin-top:6px;">ЧСС: <button data-следующий style="${СТИЛЬ_ССЫЛКИ}">Кадр следующего КД — текущий</button> `
    + (цикл ? `цикл ${кадровСлово(цикл)}` : '<span style="color:#8fa3c0;">не отмечен</span>')
    + (с.мсНаКадр ? ` <span style="color:#8fa3c0;">(кадр ${запятая(с.мсНаКадр, 2)} мс, ${escapeHtml(с.откудаВремя)})</span>` : ' <span style="color:#8fa3c0;">(времени кадра в файле нет — ЧСС не посчитать)</span>')
    + '</div>');
  стр.push(текстИтогаДвух());
  стр.push(текстИтога());
  стр.push(`<div style="${СТИЛЬ_ОГОВОРОК}">${оговоркиСимпсона().map(escapeHtml).join('<br>')}</div>`);
}

/** [12.0.47] Поля роста, веса и пола — общие для камер и длинной оси. */
function поляПациента(сПолом) {
  return `<div style="margin-bottom:8px;">Рост <input data-рост type="number" min="40" max="250" step="1" value="${с.рост ?? ''}" style="width:62px;${СТИЛЬ_ПОЛЯ}"> см · `
    + `вес <input data-вес type="number" min="2" max="400" step="0.1" value="${с.вес ?? ''}" style="width:62px;${СТИЛЬ_ПОЛЯ}"> кг`
    + (сПолом ? ` · пол <select data-пол style="${СТИЛЬ_ПОЛЯ}"><option value="" ${с.пол ? '' : 'selected'}>—</option>`
      + `<option value="ж" ${с.пол === 'ж' ? 'selected' : ''}>ж</option><option value="м" ${с.пол === 'м' ? 'selected' : ''}>м</option></select>` : '')
    + ' <span style="color:#8fa3c0;font-size:12px;">— для индексов' + (сПолом ? ' и норм' : '') + '</span></div>';
}

/** [12.0.47] Вкладка «Длинная ось»: линейные размеры, масса, геометрия. */
function вкладкаОси(стр, текущий) {
  стр.push(поляПациента(true));
  const группы = [
    ['Конец диастолы — на уровне концов створок МК', ['мжп', 'кдр', 'зслж']],
    ['Конец систолы', ['кср']],
    ['Выносящий тракт, аорта, ЛП', ['втлж', 'аорта', 'лпд']],
  ];
  for (const [заголовок, виды] of группы) {
    стр.push(`<div style="margin-top:8px;font-weight:700;color:#c9d6ea;">${заголовок}</div>`);
    for (const вид of виды) {
      стр.push(`<div style="display:flex;gap:6px;align-items:baseline;flex-wrap:wrap;margin-top:4px;">`
        + `<button data-обвести="${вид}" style="${СТИЛЬ_КНОПКИ}min-width:128px;">${подписьКнопки(вид, текущий)}</button>`
        + `<span style="font-size:12.5px;">${escapeHtml(ВИДЫ[вид].имя)}: ${строкаЗамера(вид)}</span></div>`);
    }
  }
  const св = итогОсиОкна();
  if (св.строки.length) {
    стр.push('<table style="width:100%;margin-top:8px;border-collapse:collapse;font-size:12.5px;">');
    let группа = '';
    for (const ст of св.строки) {
      if (ст.группа !== группа) { группа = ст.группа; стр.push(`<tr><td colspan="2" style="padding-top:6px;color:#9fb3cf;font-weight:700;">${escapeHtml(группа)}</td></tr>`); }
      стр.push(`<tr><td style="padding:2px 0;">${escapeHtml(ст.имя)}</td><td style="text-align:right;white-space:nowrap;${ст.вне ? 'color:#ffb86b;font-weight:700;' : ''}">`
        + `${запятая(ст.значение, ст.знаков)}${ст.ед ? ' ' + escapeHtml(ст.ед) : ''}</td></tr>`);
      if (ст.вне) стр.push(`<tr><td colspan="2" style="color:#ffb86b;font-size:11.5px;padding-bottom:2px;">${escapeHtml(ст.вне)}</td></tr>`);
    }
    стр.push('</table>');
    if (св.геометрия) стр.push(`<div style="margin-top:6px;">Геометрия ЛЖ: <b>${escapeHtml(св.геометрия)}</b></div>`);
  }
  if (!(с.масштаб.мм > 0)) стр.push('<div style="margin-top:6px;color:#e8d9a8;">Без масштаба размеров нет — задайте масштаб вверху окна.</div>');
  for (const о of св.оговорки) стр.push(`<div style="color:#e8d9a8;">${escapeHtml(о)}</div>`);
  стр.push(`<div style="${СТИЛЬ_ОГОВОРОК}">${оговоркиДлиннойОси().map(escapeHtml).join('<br>')}</div>`);
}

function вкладкаКамер(стр, текущий) {
  стр.push(поляПациента(false));
  const группы = [
    ['ЛП и ПП — кадр конца систолы ЛЖ (предсердия наибольшие)', ['лп', 'пп']],
    ['ПЖ — площади в конце диастолы и систолы, отрезки в конце диастолы', ['пжкд', 'пжкс', 'пж1', 'пж2', 'пж3']],
    ['Кольца', ['тк', 'мк']],
  ];
  for (const [заголовок, виды] of группы) {
    стр.push(`<div style="margin-top:8px;font-weight:700;color:#c9d6ea;">${заголовок}</div>`);
    for (const вид of виды) {
      стр.push(`<div style="display:flex;gap:6px;align-items:baseline;flex-wrap:wrap;margin-top:4px;">`
        + `<button data-обвести="${вид}" style="${СТИЛЬ_КНОПКИ}min-width:128px;">${подписьКнопки(вид, текущий)}</button>`
        + `<span style="font-size:12.5px;">${escapeHtml(ВИДЫ[вид].имя)}: ${строкаЗамера(вид)}</span></div>`);
    }
  }
  стр.push('<div style="margin-top:6px;color:#8fa3c0;font-size:12px;">ЛЖ (площади, FAC, сферичность) берётся из контуров КД и КС на вкладке «ФВ».</div>');
  const св = итогКамерОкна();
  if (св.строки.length) {
    стр.push('<table style="width:100%;margin-top:8px;border-collapse:collapse;font-size:12.5px;">');
    let группа = '';
    for (const ст of св.строки) {
      if (ст.группа !== группа) { группа = ст.группа; стр.push(`<tr><td colspan="2" style="padding-top:6px;color:#9fb3cf;font-weight:700;">${escapeHtml(группа)}</td></tr>`); }
      стр.push(`<tr><td style="padding:2px 0;">${escapeHtml(ст.имя)}</td><td style="text-align:right;white-space:nowrap;${ст.вне ? 'color:#ffb86b;font-weight:700;' : ''}">`
        + `${запятая(ст.значение, ст.знаков)}${ст.ед ? ' ' + escapeHtml(ст.ед) : ''}</td></tr>`);
      if (ст.вне) стр.push(`<tr><td colspan="2" style="color:#ffb86b;font-size:11.5px;padding-bottom:2px;">${escapeHtml(ст.вне)}</td></tr>`);
    }
    стр.push('</table>');
  }
  if (!(с.масштаб.мм > 0)) стр.push('<div style="margin-top:6px;color:#e8d9a8;">Без масштаба показаны только FAC и индекс сферичности — им масштаб не нужен.</div>');
  for (const о of св.оговорки) стр.push(`<div style="color:#e8d9a8;">${escapeHtml(о)}</div>`);
  стр.push(`<div style="${СТИЛЬ_ОГОВОРОК}">${оговоркиКамер().map(escapeHtml).join('<br>')}</div>`);
}

// ══════════════════════════════════════════════════════════════
//  [12.0.44] Движение колец: анатомический М-режим
// ══════════════════════════════════════════════════════════════

/**
 * Собрать М-режим по линии со всех кадров клипа и найти след кольца.
 * Каждый кадр грузится через кэш Cornerstone (как при листании) и тут же
 * сводится к одному столбцу — целые кадры в памяти не держатся.
 */
async function построитьМ(ключ, замер) {
  const линия = линияМ(замер.пикс[0], замер.пикс[1]);
  if (!линия.ок) { showToast(`${ЛИНИИ[ключ].имя}: ${линия.причина}`, 'warning', 6000); return; }
  let ids = [];
  try { ids = с.vp.getImageIds() || []; } catch (e) { ids = []; }
  if (ids.length < 5) { showToast('Для М-режима нужен клип: в этом окне меньше пяти кадров', 'warning', 6000); return; }
  const д = { линия, кадр: замер.кадр, М: null, след: null, отметки: [], строится: 0, всего: ids.length, серия: серия() };
  с.движение[ключ] = д;
  const мой = д;
  const М = [];
  try {
    for (let k = 0; k < ids.length; k++) {
      const image = await cornerstone.imageLoader.loadAndCacheImage(ids[k]);
      if (с.движение[ключ] !== мой) return;                 // линию перепровели, пока строили
      const п = image.getPixelData();
      const w = image.columns, h = image.rows;
      const комп = Math.round(п.length / (w * h));
      if (![1, 3, 4].includes(комп)) throw new Error(`кадр ${k + 1}: непонятный формат пикселей`);
      М.push(столбецМ(п, w, h, комп, линия));
      д.строится = k + 1;
      if (k % 12 === 0 && с.вкладка === 'движение') обновитьОкно();
    }
    д.М = М;
    д.след = следКольца(М, { кадр: замер.кадр, якорь: линия.якорь, ммНаПиксель: с.масштаб.мм });
    if (!д.след.ок) showToast(`${ЛИНИИ[ключ].имя}: ${д.след.причина}`, 'warning', 7000);
    log.info(`[Движение] ${ключ}: М-режим ${М.length}×${М[0].length}, след ${д.след.ок ? 'есть' : 'нет — ' + д.след.причина}`);
  } catch (e) {
    д.ошибка = e?.message || String(e);
    log.warn('[Движение] М-режим не собран:', д.ошибка);
    showToast(`М-режим не собран: ${д.ошибка}`, 'error', 7000);
  }
  д.строится = 0;
  нарисовать(); обновитьОкно();
}

function итогДвиженияОкна() {
  const линии = {};
  for (const [к, д] of Object.entries(с.движение)) if (д?.М) линии[к] = { след: д.след, отметки: д.отметки };
  return итогДвижения(линии, { ммНаПиксель: с.масштаб.мм, мсНаКадр: с.мсНаКадр });
}

const М_ШАГ_Х = 3, М_ШАГ_Y = 2;   // пикселей холста на кадр и на пиксель линии

/** Нарисовать картинку М-режима одной линии со следом, фазами, отметками и текущим кадром. */
function нарисоватьМ(холст, ключ) {
  const д = с.движение[ключ];
  if (!холст || !д?.М) return;
  const n = д.М.length, N = д.М[0].length;
  холст.width = n * М_ШАГ_Х; холст.height = N * М_ШАГ_Y;
  const cx = холст.getContext('2d');
  if (!cx) return;
  const картинка = cx.createImageData(n, N);
  for (let k = 0; k < n; k++) {
    const ст = д.М[k];
    for (let t = 0; t < N; t++) {
      const v = Math.max(0, Math.min(255, ст[t])) | 0;
      const i = ((N - 1 - t) * n + k) * 4;       // верх картинки — к верхушке
      картинка.data[i] = картинка.data[i + 1] = картинка.data[i + 2] = v; картинка.data[i + 3] = 255;
    }
  }
  const тмп = document.createElement('canvas');
  тмп.width = n; тмп.height = N;
  тмп.getContext('2d').putImageData(картинка, 0, 0);
  cx.imageSmoothingEnabled = false;
  cx.drawImage(тмп, 0, 0, холст.width, холст.height);
  const X = (k) => (k + 0.5) * М_ШАГ_Х, Y = (t) => (N - 1 - t + 0.5) * М_ШАГ_Y;
  const р = итогДвиженияОкна().разборы[ключ];
  if (д.след?.ок) {
    cx.strokeStyle = д.отметки.length ? 'rgba(255,85,85,0.45)' : '#ff5555';
    cx.lineWidth = 1.5;
    cx.beginPath();
    д.след.след.forEach((t, k) => (k ? cx.lineTo(X(k), Y(t)) : cx.moveTo(X(k), Y(t))));
    cx.stroke();
  }
  const метка = (k, цвет) => { cx.fillStyle = цвет; cx.fillRect(X(k) - 1.5, 0, 3, 8); };
  for (const k of р?.кд || []) метка(k, '#58a6ff');
  for (const k of р?.кс || []) метка(k, '#f0883e');
  for (const о of д.отметки) {
    cx.fillStyle = о.вид === 'кд' ? '#58a6ff' : '#f0883e';
    cx.beginPath(); cx.arc(X(о.кадр), Y(о.t), 4, 0, Math.PI * 2); cx.fill();
  }
  let т = null;
  try { т = с.vp?.getCurrentImageIdIndex(); } catch (e) { т = null; }
  if (т != null && т < n) { cx.strokeStyle = 'rgba(126,231,135,0.9)'; cx.lineWidth = 1; cx.beginPath(); cx.moveTo(X(т), 0); cx.lineTo(X(т), холст.height); cx.stroke(); }
}

function нарисоватьВсеМ() {
  if (!с.окно) return;
  for (const х of с.окно.querySelectorAll('canvas[data-мрежим]')) нарисоватьМ(х, х.getAttribute('data-мрежим'));
}

/** Щелчок по картинке М-режима: отметка (если включена) или переход к кадру. */
async function щелчокПоМ(холст, e) {
  const ключ = холст.getAttribute('data-мрежим');
  const д = с.движение[ключ];
  if (!д?.М) return;
  const r = холст.getBoundingClientRect();
  const x = (e.clientX - r.left) * (холст.width / r.width), y = (e.clientY - r.top) * (холст.height / r.height);
  const n = д.М.length, N = д.М[0].length;
  const кадр = Math.max(0, Math.min(n - 1, Math.floor(x / М_ШАГ_Х)));
  const t = Math.max(0, Math.min(N - 1, N - 1 - y / М_ШАГ_Y + 0.5));
  if (с.ставлю?.ключ === ключ) {
    д.отметки.push({ кадр, t, вид: с.ставлю.вид });
    с.ставлю = { ключ, вид: с.ставлю.вид === 'кд' ? 'кс' : 'кд' };   // дальше — парная отметка
    обновитьОкно();
    return;
  }
  try { await с.vp.setImageIdIndex(кадр); } catch (err) { log.debug('[Движение] переход', err.message); }
}

function вкладкаДвижения(стр, текущий) {
  стр.push('<div style="color:#9fb3cf;font-size:12.5px;margin-bottom:6px;">Как курсор М-режима: первый щелчок — на кольцо (его край со стороны желудочка), второй — к верхушке по ходу движения кольца. Удобнее на кадре конца диастолы. Программа соберёт М-режим со всех кадров.</div>');
  for (const вид of ДВИЖЕНИЕ) {
    const в = ВИДЫ[вид], ключ = в.линия, д = с.движение[ключ];
    стр.push(`<div style="margin-top:8px;display:flex;gap:6px;align-items:baseline;flex-wrap:wrap;">`
      + `<button data-обвести="${вид}" style="${СТИЛЬ_КНОПКИ}min-width:128px;">${подписьКнопки(вид, текущий)}</button>`
      + `<span style="font-size:12.5px;font-weight:700;color:${в.цвет};">${escapeHtml(ЛИНИИ[ключ].имя)} — ${escapeHtml(ЛИНИИ[ключ].показатель)}</span></div>`);
    if (!д) continue;
    if (д.строится) { стр.push(`<div style="color:#8fa3c0;">Собираю М-режим: кадр ${д.строится} из ${д.всего}…</div>`); continue; }
    if (д.ошибка) { стр.push(`<div style="color:#ffb4a8;">${escapeHtml(д.ошибка)}</div>`); continue; }
    if (!д.М) continue;
    стр.push(`<canvas data-мрежим="${ключ}" style="width:100%;height:150px;margin-top:4px;border-radius:6px;cursor:${с.ставлю?.ключ === ключ ? 'crosshair' : 'pointer'};image-rendering:pixelated;"></canvas>`);
    const ставлю = с.ставлю?.ключ === ключ ? с.ставлю.вид : null;
    стр.push(`<div style="display:flex;gap:6px;flex-wrap:wrap;margin-top:4px;font-size:12px;">`
      + `<button data-ставить="${ключ}" style="${СТИЛЬ_ССЫЛКИ}${ставлю ? 'background:#24324a;' : ''}">${ставлю ? `Ставлю ${ставлю === 'кд' ? 'КД' : 'КС'} — щёлкайте по картинке (выключить)` : 'Отметить КД и КС вручную'}</button>`
      + (д.отметки.length ? `<button data-отметки-убрать="${ключ}" style="${СТИЛЬ_ССЫЛКИ}">Убрать последнюю отметку</button><button data-отметки-сброс="${ключ}" style="${СТИЛЬ_ССЫЛКИ}">Вернуть след</button>` : '')
      + '</div>');
    if (!д.след?.ок && !д.отметки.length) стр.push(`<div style="color:#ffb4a8;">След не найден: ${escapeHtml(д.след?.причина || '')}. Отметьте КД и КС вручную.</div>`);
  }
  стр.push('<div style="margin-top:6px;color:#8fa3c0;font-size:12px;">На картинке: верх — к верхушке, вправо — время. Красное — след кольца, синие метки — конец диастолы, оранжевые — конец систолы, зелёная черта — текущий кадр. Щелчок по картинке — переход к кадру.</div>');
  const и = итогДвиженияОкна();
  if (и.строки.length) {
    стр.push('<table style="width:100%;margin-top:8px;border-collapse:collapse;font-size:12.5px;">');
    for (const ст of и.строки) {
      стр.push(`<tr><td style="padding:2px 0;">${escapeHtml(ст.имя)}${ст.откуда === 'отметки врача' ? ' <span style="color:#8fa3c0;">(по отметкам)</span>' : ''}</td>`
        + `<td style="text-align:right;white-space:nowrap;${ст.вне ? 'color:#ffb86b;font-weight:700;' : ''}">${запятая(ст.значение, ст.знаков)} ${escapeHtml(ст.ед)}</td></tr>`);
      if (ст.поЦиклам.length) стр.push(`<tr><td colspan="2" style="color:#8fa3c0;font-size:11.5px;">по циклам: ${ст.поЦиклам.map((v) => запятая(v, ст.знаков)).join('; ')}</td></tr>`);
      if (ст.вне) стр.push(`<tr><td colspan="2" style="color:#ffb86b;font-size:11.5px;">${escapeHtml(ст.вне)}</td></tr>`);
    }
    стр.push('</table>');
  }
  if (и.фазы) {
    const к = (k, имя) => `<button data-кадр="${k}" style="${СТИЛЬ_ССЫЛКИ}">${имя} ${k + 1}</button>`;
    стр.push(`<div style="margin-top:8px;"><b>Подсказка кадров</b> <span style="color:#8fa3c0;">(по линии «${escapeHtml(и.фазыПо)}»)</span>:<br>`
      + `КД: ${и.фазы.кд.map((k) => к(k, 'кадр')).join(' ') || '—'}<br>КС: ${и.фазы.кс.map((k) => к(k, 'кадр')).join(' ') || '—'}</div>`);
  }
  if (и.rr.length) {
    стр.push(`<div style="margin-top:6px;">${и.чсс ? `ЧСС <b>${запятая(и.чсс, 0)}</b> в минуту; по циклам: ${и.rr.map((r) => (r.чсс ? запятая(r.чсс, 0) : '—')).join('; ')}` : `циклы: ${и.rr.map((r) => кадровСлово(r.кадров)).join('; ')}`}`
      + (и.разбросRR != null ? ` · разброс промежутков ${запятая(и.разбросRR * 100, 0)}%` : '') + '</div>');
  }
  for (const о of и.оговорки) стр.push(`<div style="color:#e8d9a8;">${escapeHtml(о)}</div>`);
  стр.push(`<div style="${СТИЛЬ_ОГОВОРОК}">${оговоркиДвижения().map(escapeHtml).join('<br>')}</div>`);
}

/** [12.0.44] Строки отчёта о движении колец. */
function текстДвижения() {
  const и = итогДвиженияОкна();
  if (!и.строки.length && !и.оговорки.length) return [];
  const стр = ['Движение колец (анатомический М-режим по B-режиму, 4-камерная позиция)'];
  for (const ст of и.строки) {
    стр.push(`${ст.имя}: ${запятая(ст.значение, ст.знаков)} ${ст.ед}${ст.поЦиклам.length > 1 ? ` (по циклам ${ст.поЦиклам.map((v) => запятая(v, ст.знаков)).join('; ')})` : ''}`
      + `${ст.откуда === 'отметки врача' ? ', по отметкам врача' : ''}${ст.вне ? ` — ${ст.вне}` : ''}`);
  }
  if (и.фазы) стр.push(`Кадры КД: ${и.фазы.кд.map((k) => k + 1).join(', ') || '—'}; КС: ${и.фазы.кс.map((k) => k + 1).join(', ') || '—'} (по линии «${и.фазыПо}»)`);
  if (и.чсс) стр.push(`ЧСС ${запятая(и.чсс, 0)} в минуту (по циклам ${и.rr.map((r) => запятая(r.чсс, 0)).join('; ')})${и.разбросRR != null ? `, разброс промежутков ${запятая(и.разбросRR * 100, 0)}%` : ''}`);
  for (const о of и.оговорки) стр.push(о);
  стр.push(...оговоркиДвижения());
  return стр;
}

function обновитьОкно() {
  const тело = с.окно?.querySelector('[data-тело]');
  if (!тело) return;
  let текущий = null;
  try { текущий = с.vp?.getCurrentImageIdIndex(); } catch (e) { текущий = null; }
  for (const к of с.окно.querySelectorAll('button[data-вкладка]')) {
    const своя = к.getAttribute('data-вкладка') === с.вкладка;
    к.style.background = своя ? '#24324a' : '#131a26';
    к.style.fontWeight = своя ? '700' : '400';
  }
  const о = с.обводка;
  const стр = [];
  стр.push(`<div style="margin-bottom:8px;">Масштаб: <input data-масштаб type="number" min="0" step="0.001" value="${с.масштаб.мм > 0 ? (+с.масштаб.мм.toFixed(5)) : ''}"`
    + ` style="width:92px;${СТИЛЬ_ПОЛЯ}"> мм на пиксель`
    + ` <button data-обвести="метки" style="${СТИЛЬ_ССЫЛКИ}">По меткам линейки</button>`
    + (с.метки ? `<div style="margin-top:4px;">Между метками <input data-см-меток type="number" min="0.5" max="30" step="0.5" value="${с.смМеток}" style="width:56px;${СТИЛЬ_ПОЛЯ}"> см`
      + ` <span style="color:#8fa3c0;">(${запятая(Math.hypot(с.метки.пикс[1][0] - с.метки.пикс[0][0], с.метки.пикс[1][1] - с.метки.пикс[0][1]), 0)} пикс)</span></div>` : '')
    + `<div style="color:#8fa3c0;font-size:12px;">${escapeHtml(с.масштаб.откуда)}. Допущение: по ширине масштаб тот же, что по глубине.</div></div>`);
  if (о) {
    const в = вид_(о.что);
    стр.push(`<div style="padding:8px 10px;border-radius:8px;background:rgba(20,70,40,0.45);border:1px solid #4a8;margin-bottom:8px;">`
      + `${escapeHtml(в.имя)}, кадр ${о.кадр + 1}. Точек ${о.мир.length}.<br>`
      + (двуточечный(о.что)
        ? `Два щелчка: ${escapeHtml(в.подсказка)}. Esc — отмена.`
        : `Щелчки: ${escapeHtml(в.подсказка)}. Двойной щелчок или Enter — готово, Backspace — убрать точку, Esc — отмена.`)
      + (текущий != null && текущий !== о.кадр ? `<br><b>Вы ушли на кадр ${текущий + 1} — замер относится к кадру ${о.кадр + 1}.</b>` : '')
      + `<div style="display:flex;gap:6px;margin-top:6px;">`
      + (двуточечный(о.что) ? '' : `<button data-готово style="${СТИЛЬ_КНОПКИ}">Готово</button>`)
      + `<button data-убрать style="${СТИЛЬ_КНОПКИ}">Убрать точку</button><button data-отмена style="${СТИЛЬ_КНОПКИ}">Отмена</button></div></div>`);
  }
  if (с.вкладка === 'камеры') вкладкаКамер(стр, текущий);
  else if (с.вкладка === 'ось') вкладкаОси(стр, текущий);
  else if (с.вкладка === 'движение') вкладкаДвижения(стр, текущий);
  else вкладкаФВ(стр, текущий);
  стр.push('<div style="margin-top:6px;color:#8fa3c0;font-size:12px;">Не для диагностики.</div>');
  тело.innerHTML = стр.join('');
  if (с.вкладка === 'движение') нарисоватьВсеМ();
}

function текстОтчёта() {
  const и = итог();
  const есть = с.кд?.мм > 0;
  const стр = [];
  // [12.0.47] Две плоскости — первыми, когда есть.
  const и2 = итогДвух();
  if (и2?.ок) {
    стр.push('ФВ ЛЖ по Симпсону, две плоскости (4- и 2-камерная позиции)');
    стр.push(`ФВ ${запятая(и2.фв * 100, 0)}%`);
    if (есть) стр.push(`КДО ${запятая(и2.кдоМЛ, 0)} мл, КСО ${запятая(и2.ксоМЛ, 0)} мл, УО ${запятая(и2.уоМЛ, 0)} мл`);
    for (const о of и2.оговорки) стр.push(о);
    стр.push('');
  }
  if (с.кд || с.кс) {
    стр.push('ФВ ЛЖ по Симпсону, одна плоскость (4-камерная позиция)');
    if (и?.ок) {
      стр.push(`ФВ ${запятая(и.фв * 100, 0)}%`);
      if (есть) стр.push(`КДО ${запятая(и.кдоМЛ, 0)} мл (кадр ${с.кд.кадр + 1}), КСО ${запятая(и.ксоМЛ, 0)} мл (кадр ${с.кс.кадр + 1}), УО ${запятая(и.уоМЛ, 0)} мл`);
      if (и.чсс) стр.push(`ЧСС ${запятая(и.чсс, 0)} в минуту${есть ? `, МО ${запятая(и.моЛМин, 1)} л/мин` : ''}`);
      for (const о of и.оговорки) стр.push(о);
    } else if (и) {
      стр.push('Не посчитано: ' + и.причина);
    }
    if (есть) {
      for (const [что, имя] of [['кд', 'КД'], ['кс', 'КС']]) {
        const к = с[что]?.итог;
        if (к?.ок) стр.push(`${имя}: длина ЛЖ ${запятая(к.длинаММ / 10, 1)} см, площадь ${запятая(к.площадьММ2 / 100, 1)} см²`);
      }
    }
    стр.push(...оговоркиСимпсона());
  }
  // [12.0.43] Камеры и кольца — той же сводкой, что в окне.
  const св = итогКамерОкна();
  if (св.строки.length) {
    if (стр.length) стр.push('');
    стр.push('Камеры и кольца (4-камерная позиция)');
    if (св.ппт) стр.push(`Площадь тела ${запятая(св.ппт, 2)} м² (рост ${с.рост} см, вес ${с.вес} кг, Мостеллер)`);
    for (const ст of св.строки) {
      стр.push(`${ст.имя}: ${запятая(ст.значение, ст.знаков)}${ст.ед ? ' ' + ст.ед : ''}${ст.вне ? ` — ${ст.вне}` : ''}`);
    }
    const кадры = КАМЕРЫ.filter((в) => с[в]).map((в) => `${ВИДЫ[в].метка} — ${с[в].кадр + 1}`);
    if (кадры.length) стр.push(`Кадры замеров: ${кадры.join(', ')}`);
    for (const о of св.оговорки) стр.push(о);
    стр.push(...оговоркиКамер());
  }
  // [12.0.47] Длинная ось.
  const ось = итогОсиОкна();
  if (ось.строки.length) {
    if (стр.length) стр.push('');
    стр.push('Парастернальная длинная ось');
    if (с.пол) стр.push(`Пол: ${с.пол === 'ж' ? 'женский' : 'мужской'}`);
    for (const ст of ось.строки) стр.push(`${ст.имя}: ${запятая(ст.значение, ст.знаков)}${ст.ед ? ' ' + ст.ед : ''}${ст.вне ? ` — ${ст.вне}` : ''}`);
    if (ось.геометрия) стр.push(`Геометрия ЛЖ: ${ось.геометрия}`);
    const кадры = ОСЬ.filter((в) => с[в]).map((в) => `${ВИДЫ[в].метка} — ${с[в].кадр + 1}`);
    if (кадры.length) стр.push(`Кадры замеров: ${кадры.join(', ')}`);
    for (const о of ось.оговорки) стр.push(о);
    стр.push(...оговоркиДлиннойОси());
  }
  // [12.0.44] Движение колец.
  const дв = текстДвижения();
  if (дв.length) { if (стр.length) стр.push(''); стр.push(...дв); }
  стр.push(`Масштаб ${есть ? запятая(с.масштаб.мм, 4) + ' мм/пикс' : 'не задан'} — ${с.масштаб.откуда}`);
  стр.push('Не для диагностики.');
  return стр.join('\n');
}

/**
 * [12.0.47] В окне снимка открыли другой клип (например, 2-камерную позицию
 * после 4-камерной). Замеры прежнего клипа остаются со своим масштабом; для
 * нового масштаб и время кадра читаются заново, метки линейки снимаются —
 * они были на том клипе.
 */
async function новаяСерия() {
  с.серияОкна = серия();
  с.метки = null;
  let id = null;
  try { id = с.vp.getCurrentImageId?.() || с.vp.getImageIds()[с.vp.getCurrentImageIdIndex()]; } catch (e) { id = null; }
  if (!id) return;
  const м = await определитьМасштаб(id);
  if (с.серияОкна !== серия()) return;                      // пока читали, сменили ещё раз
  с.масштаб = м;
  const в = await времяКадра(id);
  с.мсНаКадр = в.мс; с.откудаВремя = в.откуда;
  log.info(`[Симпсон] другой клип: масштаб ${с.масштаб.мм ?? 'нет'} — ${с.масштаб.откуда}`);
  нарисовать(); обновитьОкно();
}

/** [12.0.45] Масштаб по меткам линейки — в поле масштаба и во все замеры. */
function применитьМетки() {
  if (!с.метки) return;
  const м = масштабПоМеткам(с.метки.пикс[0], с.метки.пикс[1], с.смМеток);
  if (!м.ок) { showToast('Масштаб по меткам: ' + м.причина, 'warning', 6000); return; }
  с.масштаб.мм = м.ммНаПиксель;
  с.масштаб.откуда = `по двум меткам линейки: ${запятая(с.смМеток, 1)} см = ${запятая(м.пикс, 0)} пикс (кадр ${с.метки.кадр + 1})`;
  for (const вид of Object.keys(ВИДЫ)) пересчитать(с[вид]);
  log.info(`[Симпсон] масштаб по меткам: ${м.ммНаПиксель.toFixed(4)} мм/пикс`);
}

function сброситьЗамеры() {
  for (const вид of Object.keys(ВИДЫ)) с[вид] = null;
  с.следующийКД = null; с.обводка = null;
  с.движение = {}; с.ставлю = null;   // [12.0.44]
}

function закрыть() {
  закончитьОбводкуСлужебно();
  try { с.ac?.abort(); } catch (e) { /* */ }
  try { с.svg?.remove(); } catch (e) { /* */ }
  try { с.окно?.remove(); } catch (e) { /* */ }
  сброситьЗамеры();
  Object.assign(с, { окно: null, svg: null, vp: null, элемент: null, ac: null });
}

export async function открытьСимпсон(вкладка = 'фв') {
  try {
    if (с.окно) закрыть();
    с.вкладка = ['камеры', 'движение', 'ось'].includes(вкладка) ? вкладка : 'фв';
    const а = активноеОкно();
    if (!а.ок) { showToast('ФВ по Симпсону: ' + а.причина, 'warning', 6000); return null; }
    с.vp = а.vp; с.элемент = а.элемент;
    с.ac = new AbortController();
    const imageId = (() => { try { return с.vp.getCurrentImageId?.() || с.vp.getImageIds()[с.vp.getCurrentImageIdIndex()]; } catch (e) { return null; } })();
    if (!imageId) { showToast('ФВ по Симпсону: в окне нет кадра', 'warning', 5000); с.vp = null; return null; }

    const окно = document.createElement('div');
    окно.setAttribute('data-echo-simpson-window', '');
    окно.style.cssText = 'position:fixed;top:70px;right:12px;width:min(400px,calc(100vw - 24px));max-height:calc(100vh - 90px);overflow:auto;'
      + 'z-index:50000;background:#0f1420;border:1px solid #2a3546;border-radius:14px;padding:12px 14px;color:#dbe6f5;font-size:13px;line-height:1.45;'
      + 'box-shadow:0 10px 40px rgba(0,0,0,0.6);';
    окно.innerHTML = '<div style="display:flex;align-items:center;gap:8px;margin-bottom:8px;">'
      + '<div style="font-size:15px;font-weight:700;flex:1;">ЭхоКГ</div>'
      + `<button data-закрыть style="${СТИЛЬ_КНОПКИ}" aria-label="Закрыть">✕</button></div>`
      + `<div style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:10px;"><button data-вкладка="фв" style="${СТИЛЬ_КНОПКИ}flex:1;">ФВ (Симпсон)</button>`
      + `<button data-вкладка="камеры" style="${СТИЛЬ_КНОПКИ}flex:1;">Камеры и кольца</button>`
      + `<button data-вкладка="движение" style="${СТИЛЬ_КНОПКИ}flex:1;">Движение колец</button>`
      + `<button data-вкладка="ось" style="${СТИЛЬ_КНОПКИ}flex:1;">Длинная ось</button></div>`
      + '<div data-тело>Читаю масштаб и время кадра…</div>'
      + `<div style="display:flex;gap:6px;margin-top:10px;"><button data-копировать style="${СТИЛЬ_КНОПКИ}flex:1;">Скопировать</button>`
      + `<button data-сбросить style="${СТИЛЬ_КНОПКИ}flex:1;">Сбросить замеры</button></div>`;
    document.body.appendChild(окно);
    с.окно = окно;
    поставитьСлой();

    окно.addEventListener('click', async (e) => {
      const м = e.target.closest?.('canvas[data-мрежим]');
      if (м) { щелчокПоМ(м, e); return; }
      const к = e.target.closest?.('button');
      if (!к) return;
      // [12.0.44] Движение колец: ручные отметки и переход к кадру из подсказки.
      if (к.hasAttribute('data-ставить')) {
        const ключ = к.getAttribute('data-ставить');
        с.ставлю = с.ставлю?.ключ === ключ ? null : { ключ, вид: 'кд' };
        обновитьОкно(); return;
      }
      if (к.hasAttribute('data-отметки-убрать')) { с.движение[к.getAttribute('data-отметки-убрать')]?.отметки.pop(); обновитьОкно(); return; }
      if (к.hasAttribute('data-отметки-сброс')) {
        const д = с.движение[к.getAttribute('data-отметки-сброс')];
        if (д) д.отметки = [];
        с.ставлю = null; обновитьОкно(); return;
      }
      if (к.hasAttribute('data-кадр')) {
        try { await с.vp.setImageIdIndex(Number(к.getAttribute('data-кадр'))); } catch (err) { log.debug('[Движение] переход', err.message); }
        return;
      }
      if (к.hasAttribute('data-закрыть')) { закрыть(); return; }
      if (к.hasAttribute('data-вкладка')) { с.вкладка = к.getAttribute('data-вкладка'); обновитьОкно(); return; }
      if (к.hasAttribute('data-обвести')) { начатьОбводку(к.getAttribute('data-обвести')); return; }
      if (к.hasAttribute('data-готово')) { закончитьОбводку(); return; }
      if (к.hasAttribute('data-убрать')) { убратьТочку(); return; }
      if (к.hasAttribute('data-отмена')) { отменитьОбводку(); return; }
      if (к.hasAttribute('data-перейти')) {
        const замер = с[к.getAttribute('data-перейти')];
        if (замер && !наЭтойСерии(замер)) { showToast('Этот замер сделан на другом клипе — откройте его в окне снимка', 'info', 4000); return; }
        if (замер) { try { await с.vp.setImageIdIndex(замер.кадр); } catch (err) { log.debug('[Симпсон] переход', err.message); } }
        return;
      }
      if (к.hasAttribute('data-следующий')) {
        let т = null;
        try { т = с.vp.getCurrentImageIdIndex(); } catch (err) { т = null; }
        if (!с.кд) { showToast('Сначала обведите КД — цикл считается от его кадра', 'warning', 4000); return; }
        if (т == null || т === с.кд.кадр) { showToast('Встаньте на кадр СЛЕДУЮЩЕГО конца диастолы — сейчас открыт кадр КД', 'warning', 4500); return; }
        с.следующийКД = т; обновитьОкно(); return;
      }
      if (к.hasAttribute('data-сбросить')) {
        сброситьЗамеры();
        закончитьОбводкуСлужебно(); нарисовать(); обновитьОкно(); return;
      }
      if (к.hasAttribute('data-копировать')) {
        try { await navigator.clipboard.writeText(текстОтчёта()); showToast('Скопировано', 'success', 1500); }
        catch (err) { showToast('Скопировать не удалось — выделите текст в окне вручную', 'warning', 3000); }
      }
    }, { signal: с.ac.signal });
    окно.addEventListener('change', (e) => {
      const поле = e.target;
      if (поле.hasAttribute?.('data-рост') || поле.hasAttribute?.('data-вес')) {
        const v = Number(String(поле.value).replace(',', '.'));
        const ключ = поле.hasAttribute('data-рост') ? 'рост' : 'вес';
        с[ключ] = String(поле.value).trim() && Number.isFinite(v) && v > 0 ? v : null;
        обновитьОкно(); return;
      }
      if (поле.hasAttribute?.('data-пол')) { с.пол = поле.value || null; обновитьОкно(); return; }   // [12.0.47]
      if (поле.hasAttribute?.('data-см-меток')) {
        с.смМеток = Number(String(поле.value).replace(',', '.'));
        применитьМетки(); нарисовать(); обновитьОкно(); return;
      }
      if (!поле.hasAttribute?.('data-масштаб')) return;
      const v = Number(String(поле.value).replace(',', '.'));
      if (v > 0 && v < 10) { с.масштаб.мм = v; с.масштаб.откуда = 'введён вручную'; с.метки = null; }
      else if (!String(поле.value).trim()) { с.масштаб.мм = null; с.масштаб.откуда = выбратьМасштаб(null, null).откуда; }
      else { showToast('Масштаб — число больше 0 и меньше 10 мм на пиксель', 'warning', 3500); }
      for (const вид of Object.keys(ВИДЫ)) пересчитать(с[вид]);
      нарисовать(); обновитьОкно();
    }, { signal: с.ac.signal });
    // Номер текущего кадра в подписях кнопок — живой.
    с.элемент?.addEventListener(СОБЫТИЕ_ОТРИСОВКИ, () => {
      if (!с.обводка) обновитьКнопкиКадра();
      if (с.вкладка === 'движение') нарисоватьВсеМ();   // [12.0.44] зелёная черта текущего кадра
      if (серия() && серия() !== с.серияОкна) новаяСерия();   // [12.0.47] в окно снимка открыли другой клип
    }, { signal: с.ac.signal });

    с.серияОкна = серия();
    с.масштаб = await определитьМасштаб(imageId);
    const в = await времяКадра(imageId);
    с.мсНаКадр = в.мс; с.откудаВремя = в.откуда;
    log.info(`[Симпсон] масштаб ${с.масштаб.мм ?? 'нет'} — ${с.масштаб.откуда}; кадр ${с.мсНаКадр ?? '?'} мс`);
    обновитьОкно();
    нарисовать();
    return true;
  } catch (e) {
    log.warn('[Симпсон]', e.message);
    showToast('ФВ по Симпсону: окно не открылось — ' + e.message, 'error', 6000);
    return null;
  }
}

/** Только подписи кнопок «Обвести … (кадр N)», без перестройки всего окна. */
function обновитьКнопкиКадра() {
  if (!с.окно) return;
  let т = null;
  try { т = с.vp?.getCurrentImageIdIndex(); } catch (e) { т = null; }
  for (const к of с.окно.querySelectorAll('button[data-обвести]')) {
    const вид = к.getAttribute('data-обвести');
    if (ВИДЫ[вид]) к.textContent = подписьКнопки(вид, т);
  }
}

export function initEchoSimpson() {
  if (_ac) _ac.abort();
  _ac = new AbortController();
  $('btn-echo-simpson')?.addEventListener('click', () => { открытьСимпсон('фв'); }, { signal: _ac.signal });
  // [12.0.43] То же окно, сразу на вкладке «Камеры и кольца».
  $('btn-echo-chambers')?.addEventListener('click', () => { открытьСимпсон('камеры'); }, { signal: _ac.signal });
  // [12.0.44] То же окно, сразу на вкладке «Движение колец».
  $('btn-echo-motion')?.addEventListener('click', () => { открытьСимпсон('движение'); }, { signal: _ac.signal });
  // [12.0.47] То же окно, сразу на вкладке «Длинная ось».
  $('btn-echo-plax')?.addEventListener('click', () => { открытьСимпсон('ось'); }, { signal: _ac.signal });
  log.info('[Симпсон] кнопки привязаны');
}

export default { initEchoSimpson, открытьСимпсон };
